import type { FeatureCollection } from "geojson";

import { Sector } from "api/model";
import type { Bounds } from "context/PlotMap/geo";

export const BOUNDARY_COLOR = "#ff0000";

/** Stable empty collection so a source can stay mounted with nothing to draw. */
export const EMPTY_FEATURE_COLLECTION: FeatureCollection = {
  features: [],
  type: "FeatureCollection",
};
export const GROWER_LABEL_BG_COLOR = "#7f0000";
export const LABEL_FILL_COLOR = "#ffffff";
export const LABEL_PLAQUE_PADDING = 4;
export const PLOT_LABEL_BG_COLOR = "#003d4d";
/**
 * Hide individual plot-cell labels below this zoom. Default plots are ~3–6 m,
 * so centroids are closer than a 14px plaque until the user is well zoomed in.
 */
export const PLOT_LABEL_MIN_ZOOM = 19.5;
export const ROW_BOUNDARY_COLOR = "#ffeb3b";
export const ROW_LABEL_BG_COLOR = "#000000";
/**
 * Hide row-number labels below this zoom. A crop row is about a meter wide
 * and the label runs along the long side, so a 14px plaque only fits inside
 * the row once the map is zoomed in past the plot labels.
 */
export const ROW_LABEL_MIN_ZOOM = 21.5;
export const SITE_BOUNDARY_COLOR = "#ffeb3b";
export const SITE_LABEL_BG_COLOR = "#7a6b00";
export const TRIAL_LABEL_BG_COLOR = "#00727f";
/**
 * Region to frame when returning to the location overview from a location in
 * that sector. Each box is [[west, south], [east, north]]. Sectors without an
 * entry fall back to fitting the location markers.
 */
export const SECTOR_BOUNDS: Partial<Record<Sector, Bounds>> = {
  // Africa, the Middle East and South Asia.
  [Sector.AMESA]: [
    [-18, -35],
    [98, 42],
  ],
  // East Asia, Southeast Asia, Australia and New Zealand.
  [Sector.APAC]: [
    [73, -47],
    [180, 54],
  ],
  // Europe, from Iceland to Turkey.
  [Sector.EU]: [
    [-25, 34],
    [45, 72],
  ],
  // Central America, the Caribbean and South America.
  [Sector.LATAM]: [
    [-92, -56],
    [-34, 24],
  ],
  // Canada, the US and Mexico.
  [Sector.PFNA]: [
    [-170, 14],
    [-50, 72],
  ],
};
export const US_INITIAL_VIEW = {
  latitude: 39.8283,
  longitude: -98.5795,
  zoom: 3.5,
} as const;
